import { render, staticRenderFns } from "./ModalRuleCheckViolationsContainer.vue?vue&type=template&id=a5a5a352&scoped=true&"
import script from "./ModalRuleCheckViolationsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalRuleCheckViolationsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a5a352",
  null
  
)

export default component.exports